<template>
  <process-menu :items="assessmentPanels" />
</template>

<script>
import ProcessMenu from '@/components/ProcessMenu'

const ROLES = {
  INTERNAL_TECHNICIAN: ['internalAssessor', 'technician', 'sectionHead'],
  EXTERNAL_ASSESSOR: [
    'internalAssessor',
    'technician',
    'externalAssessor',
    'sectionHead',
  ],
  CLAIMS_OFFICER: [
    'internalAssessor',
    'technician',
    'claimOfficer',
    'sectionHead',
  ],
  ADMIN_TECHNICIAN: ['admin', 'internalAssessor', 'technician', 'sectionHead'],
  ADMIN_SECTION_HEAD: ['admin', 'internalAssessor', 'sectionHead'],
  FULL_ACCESS: [
    'admin',
    'claimOfficer',
    'internalAssessor',
    'sectionHead',
    'technician',
  ],
}

export default {
  components: { ProcessMenu },
  data: () => ({
    assessmentPanels: [
      {
        src: require('@/assets/img/assesment-center/booking.png'),
        heading: 'Vehicle Booking',
        text: 'For booking and verification service, checking assessment qualifications',
        link: { name: 'BookVehicle' },
        roles: ROLES.INTERNAL_TECHNICIAN,
      },
      {
        src: require('@/assets/img/assesment-center/vehicle-inspection.png'),
        heading: 'Internal Assessor',
        text: 'For vehicle inspection, bid analysis and supplementary approval',
        link: '/vehicle-inspection',
        roles: ROLES.INTERNAL_TECHNICIAN,
      },
      {
        src: require('@/assets/img/assesment-center/major-accident.png'),
        heading: 'External Assessor',
        text: 'Motor assessment, supplementary and re-inspection',
        link: { name: 'MajorAccident' },
        roles: ROLES.EXTERNAL_ASSESSOR,
      },
      {
        src: require('@/assets/img/assesment-center/bid-submited.png'),
        heading: 'Bids Received',
        text: 'All bids received',
        link: { name: 'BidsSubmitted' },
        roles: ROLES.INTERNAL_TECHNICIAN,
      },
      {
        src: require('@/assets/img/assesment-center/qualified-bids.png'),
        heading: 'Qualified Bids',
        text: 'Bids Qualified by Assessors',
        link: { name: 'QualifiedBids' },
        roles: ROLES.CLAIMS_OFFICER,
      },
      {
        src: require('@/assets/img/assesment-center/major-accident.png'),
        heading: 'Vehicle Checkout',
        text: 'A checklist to check out vehicles that have been analysed with key status',
        link: { name: 'VehicleCheckout' },
        roles: ROLES.ADMIN_TECHNICIAN,
      },
      {
        src: require('@/assets/img/assesment-center/all-bids.png'),
        heading: 'All Bid Reports',
        text: 'All the bids that have been submitted with an assigned garage',
        link: { name: 'BidReports' },
        roles: ROLES.CLAIMS_OFFICER,
      },
      {
        src: require('@/assets/img/assesment-center/write-off.png'),
        heading: 'Write Off Reports',
        text: 'All Written Off Reports',
        link: { name: 'WriteOffReports' },
        roles: ROLES.CLAIMS_OFFICER,
      },
      {
        src: require('@/assets/img/assesment-center/cash-in-lieu.png'),
        heading: 'Cash in Lieu Reports',
        text: 'All Cash in Lieu Reports',
        link: { name: 'CashInLieuReports' },
        roles: ROLES.CLAIMS_OFFICER,
      },
      {
        src: require('@/assets/img/assesment-center/below-excess.png'),
        heading: 'Below Excess Reports',
        text: 'All Below Excess Reports',
        link: { name: 'BelowExcessReports' },
        roles: ROLES.CLAIMS_OFFICER,
      },
      {
        src: require('@/assets/img/assesment-center/all-bids.png'),
        heading: 'Under Investigation Reports',
        text: 'For checking bids that are still under investigation',
        link: { name: 'UnderInvestigationReports' },
        roles: ROLES.ADMIN_SECTION_HEAD,
      },
      {
        src: require('@/assets/img/assesment-center/all-bids.png'),
        heading: 'Undocumented Reports',
        text: 'For checking bids that are undocumented',
        link: { name: 'UndocumentedReports' },
        roles: ROLES.ADMIN_SECTION_HEAD,
      },
      {
        src: require('@/assets/img/assesment-center/all-bids.png'),
        heading: 'Declined Reports',
        text: 'For checking bids that have been declined',
        link: { name: 'DeclinedReports' },
        roles: ROLES.FULL_ACCESS,
      },
    ],
  }),
}
</script>
